import React from 'react'
import { AchievementsList } from './list/page'

export const AchievementsPage = () => {
  return <AchievementsList />
}
